import { phoneToFhir } from './lib/phone.js'
import { transform } from './mapper.js'

const RELATIONSHIP_SNOMED = {
  text: 'Attorney',
  coding: [
    {
      system: 'http://snomed.info/sct',
      code: '429577009',
      display: 'Patient advocate'
    }
  ]
}

const firmEx = {
  url: 'http://narus.com/fhir/StructureDefinition/relatedperson-organization'
}

const livingWillEx = {
  url: 'http://narus.com/fhir/living-will-attorney'
}

const advanceDirectiveEx = {
  url: 'http://narus.com/fhir/advance-directive-attorney'
}

const dnrEx = {
  url: 'http://narus.com/fhir/dnr-attorney'
}

const postEx = {
  url: 'http://narus.com/fhir/post-polst-attorney'
}

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'RelatedPerson'
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  {
    fhir: [ 'active' ],
    fhir_const: true
  },
  {
    fhir: [ 'relationship' ],
    fhir_const: RELATIONSHIP_SNOMED
  },
  {
    fhir: [ 'name', { use: 'usual' }, 'family', 0 ],
    form: [ 'lastName' ]
  },
  {
    fhir: [ 'name', { use: 'usual' }, 'given', 0 ],
    form: [ 'firstName' ]
  },
  {
    fhir: [ 'extension', firmEx, 'valueReference', 'display' ],
    form: [ 'firm' ]
  },
  {
    fhir: [ 'extension', livingWillEx, 'valueBoolean' ],
    form: [ 'livingwill' ]
  },
  {
    fhir: [ 'extension', advanceDirectiveEx, 'valueBoolean' ],
    form: [ 'advancedDirective' ]
  },
  {
    fhir: [ 'extension', dnrEx, 'valueBoolean' ],
    form: [ 'dnr' ]
  },
  {
    fhir: [ 'extension', postEx, 'valueBoolean' ],
    form: [ 'post' ]
  },
  {
    fhir: [ 'address', { use: 'home' }, 'line', 0 ],
    form: [ 'address1' ]
  },
  {
    fhir: [ 'address', { use: 'home' }, 'line', 1 ],
    form: [ 'address2' ]
  },
  {
    fhir: [ 'address', { use: 'home' }, 'city' ],
    form: [ 'city' ]
  },
  {
    fhir: [ 'address', { use: 'home' }, 'state' ],
    form: [ 'state' ]
  },
  {
    fhir: [ 'address', { use: 'home' }, 'country' ],
    fhir_const: 'US'
  },
  {
    fhir: [ 'address', { use: 'home' }, 'postalCode' ],
    form: [ 'zip' ]
  },
  {
    fhir: [ 'telecom', {
      use: 'work',
      system: 'phone'
    }, 'value' ],
    form: [ 'phone' ],
    to_fhir: x => phoneToFhir(x)
  },
  {
    fhir: [ 'telecom', {
      use: 'work',
      system: 'email'
    }, 'value' ],
    form: [ 'email' ]
  }
]

export function toFHIR (data, ptId) {
  const res = transform(data, mapping, [ 'form', 'fhir' ])
  const ptRef = { reference: `Patient/${ptId}` }
  res.patient = ptRef
  return res
}

export function fromFHIR (data) {
  return transform(data, mapping, [ 'fhir', 'form' ])
}
